import { render, staticRenderFns } from "./add-product-modal.vue?vue&type=template&id=a7f5ea84&scoped=true&"
import script from "./add-product-modal.vue?vue&type=script&lang=js&"
export * from "./add-product-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7f5ea84",
  null
  
)

export default component.exports